export const IGNITE_ENVIRONMENTS = {
  PRODUCTION: 'production',
  PRODUCTION_EU: 'ProductionEU',
  PRODUCTION_CA: 'ProductionCA',
  QA_STAGE6: 'staging6',
  QA_STAGE8: 'staging8',
  DEVELOPMENT: 'development',
  LOCAL: 'local',
} as const;

export const IGNITE_ENV_KEYS = {
  local: 'local',
  development: 'development',
  staging6: 'staging6',
  staging8: 'staging8',
  production: 'production',
  production_eu: 'production_eu',
  production_ca: 'production_ca',
} as const;
